export const getIn = (source: unknown, path: string): unknown =>
  path
    .split('.')
    .reduce<unknown>(
      (current, key) =>
        typeof current === 'object' && current !== null ? (current as Record<string, unknown>)[key] : undefined,
      source
    )

export const setIn = (source: Record<string, unknown>, path: string, next: unknown): Record<string, unknown> => {
  const [key, ...rest] = path.split('.')

  if (rest.length === 0) {
    return { ...source, [key]: next }
  }

  const child = source[key]

  return {
    ...source,
    [key]: setIn(
      typeof child === 'object' && child !== null ? (child as Record<string, unknown>) : {},
      rest.join('.'),
      next
    ),
  }
}

export const isFilled = (candidate: unknown): boolean => {
  if (Array.isArray(candidate)) {
    return candidate.length > 0
  }

  return typeof candidate === 'string' ? candidate.trim() !== '' : candidate !== undefined && candidate !== null
}

export const textAt = (source: unknown, path: string): string => {
  const found = getIn(source, path)

  return typeof found === 'string' ? found : ''
}

export const codesAt = (source: unknown, path: string): string[] => {
  const found = getIn(source, path)

  return Array.isArray(found) ? found.filter((code): code is string => typeof code === 'string') : []
}

export const boolAt = (source: unknown, path: string, fallback: boolean): boolean => {
  const found = getIn(source, path)

  return typeof found === 'boolean' ? found : fallback
}

export const groupAt = (
  source: unknown,
  path: string
): { values: Record<string, boolean>; other: string } | undefined => {
  const found = getIn(source, path)

  if (typeof found !== 'object' || found === null) {
    return undefined
  }

  const { OTHER, ...ticks } = found as Record<string, unknown>

  return {
    values: Object.fromEntries(Object.entries(ticks).map(([key, ticked]) => [key, ticked === true])),
    other: typeof OTHER === 'string' ? OTHER : '',
  }
}
